var searchCD = 1000;
var searchListen = false;

export function callAssetSearch() {
	$("#searchstring").focus();
	$("#searchstring").on("keyup" || "change", function (e) {
		if (e.keyCode != 27) {
			searchCD = 1000;
			if (!searchListen) {
				setTimeout(searchListener,100);
				searchListen = true;
			}
			if ($("#searchstring").val().replace(/\s/g, '').length && $("#searchstring").val().length > 2) {
				//fast-search
				$("#live-search-results").css("display","none");
				$("#live-fast-search-results").show();
				$("#live-fast-search-results").html('<div style="transform:translate(50%, 50%);width:100%;height:100%;"><div class="lds-ripple" style="transform:translate(-50%,-50%);top:0px;left:0px;position:relative !important;"><div class="lds-pos"></div><div class="lds-pos"></div></div></div>');
				//$("#searchstring").addClass("loading");			
			}
			else {
				$("#live-fast-search-results").hide();
				$("#deep-search-area").hide();
				$("#live-search-results").css("display","none");
			}
		}
	});
}

export function searchListener() {
	searchCD-=100;	
	if (searchCD>0&&searchListen) { 
		setTimeout(searchListener,100);
	} else {
		searchListen=false;
		if ($("#searchstring").val().replace(/\s/g, '').length && $("#searchstring").val().length > 2) {
			//var searchString = encodeURIComponent($("#searchstring").val().trim());
			var searchString = $("#searchstring").val();
			//fast-search		
			var url = "/do_fast_search?param=" + searchString;
			$.get(url, function (html) {
				$("#searchstring").removeClass("loading");
				$("#live-fast-search-results").html(html);
				$("#deep-search-area").show();
			});			
		}
	}
}